import styled from 'styled-components';

const StyledDonutChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledDonutChartSvg = styled.div`
  position: relative;
  width: ${(props) => props.width + 'px'};
  height: ${(props) => props.height + 'px'};
`;

const StyledDonutChartText = styled.div`
  position: absolute;
  text-align: center;
`;

export { StyledDonutChartWrapper, StyledDonutChartSvg, StyledDonutChartText };
